export const textareaConfig = {
  colorScheme: {
    light: {
      disabledBackground: "{gray-50}",
      disabledColor: "{gray-500}",
      focus: {
        ringShadow: "none",
        ringOutline: "0",
        borderColor: "{primary-500}",
      },
      paddingX: "11px",
      paddingY: "7px",
      borderRadius: "var(--radius-8)",
      borderColor: "{gray-300}",
      shadow: "var(--shadow-xs)",
    },
  },
  css: ({ dt }: any) => `
    .p-textarea {
      @media screen and (max-width: 576px) {
      --p-textarea-padding-y: 4px;
      --p-textarea-padding-x: 8px;
      font-size: 14px;
    }
    }
    .p-textarea:enabled:focus {
      border: 2px solid var(--p-textarea-focus-border-color);
    }
    .p-textarea:enabled:focus.invalid-input {
      border: 2px solid var(--p-red-500);
    }
    .p-textarea-sm {
      line-height: ${dt("formField.sm.lineHeight")};
    }
    .p-textarea:enabled:hover.p-textarea.invalid-input, .p-textarea.invalid-input {
      border-color: var(--p-red-300)
    }
    .p-textarea[readonly] {
      background: var(--p-gray-50);
      color: var(--p-gray-500);
      &:focus, &:hover {
        border: 1px solid var(--p-gray-300)
      }
    }
  `,
};
